var _defs, _rect, _circle, _g, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyAnswers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-empty-answers"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140
  })))), /*#__PURE__*/React.createElement("g", {
    id: "empty-answers",
    clipPath: "url(#clip-empty-answers)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4316",
    "data-name": "Group 4316",
    transform: "translate(-219.47 -291.8)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 60,
    cy: 60,
    r: 60,
    transform: "translate(229.47 301.8)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4314",
    "data-name": "Group 4314",
    transform: "translate(249.411 329.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M262.936,372.075a32.905,32.905,0,0,0,1.419,9.6L255.462,399.3a3.609,3.609,0,0,0,4.12,5.143l18.164-4.932a31.85,31.85,0,0,0,17.439,5.173,32.321,32.321,0,0,0,23.4-10.173l-45.833-45.834A32.324,32.324,0,0,0,262.936,372.075Z",
    transform: "translate(-255.061 -339.472)",
    fill: "#adc8e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M332.443,369.468a32.167,32.167,0,0,0-54.686-23.4L323.59,391.9a32.307,32.307,0,0,0,8.854-22.429Z",
    transform: "translate(-260.072 -336.865)",
    fill: "#e0e8f6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1788",
    "data-name": "Rectangle 1788",
    d: "M279.029,371.8h38.182a1.558,1.558,0,0,1,1.558,1.558h0a1.558,1.558,0,0,1-1.558,1.558H279.029a1.558,1.558,0,0,1-1.558-1.558h0A1.558,1.558,0,0,1,279.029,371.8Z",
    transform: "translate(-10.598 -15.455)",
    fill: "#0058a7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1788-2",
    "data-name": "Rectangle 1788",
    d: "M279.029,384.8h14.805a1.559,1.559,0,0,1,1.558,1.558h0a1.559,1.559,0,0,1-1.558,1.558H279.029a1.558,1.558,0,0,1-1.558-1.558h0A1.558,1.558,0,0,1,279.029,384.8Z",
    transform: "translate(-10.598 -18.325)",
    fill: "#0058a7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1788-3",
    "data-name": "Rectangle 1788",
    d: "M279.029,358.8h38.182a1.558,1.558,0,0,1,1.558,1.558h0a1.558,1.558,0,0,1-1.558,1.558H279.029a1.558,1.558,0,0,1-1.558-1.558h0A1.558,1.558,0,0,1,279.029,358.8Z",
    transform: "translate(-10.598 -12.584)",
    fill: "#0058a7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "A",
    transform: "translate(293.237 362.915)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4315",
    "data-name": "Group 4315",
    style: {
      isolation: "isolate"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M323.606,395.859l-.826-2.17H315.75l-.826,2.218a7.775,7.775,0,0,1-.825,1.752,1.316,1.316,0,0,1-1.121.454,1.644,1.644,0,0,1-1.168-.484,1.484,1.484,0,0,1-.507-1.1,2.437,2.437,0,0,1,.118-.73q.118-.378.389-1.05l4.424-11.229q.188-.484.454-1.162a5.922,5.922,0,0,1,.566-1.126,2.3,2.3,0,0,1,.791-.725,2.424,2.424,0,0,1,1.209-.277,2.449,2.449,0,0,1,1.22.277,2.336,2.336,0,0,1,.79.714,4.934,4.934,0,0,1,.507.937q.207.5.525,1.339l4.517,11.158a5.617,5.617,0,0,1,.531,1.852,1.534,1.534,0,0,1-.5,1.1,1.648,1.648,0,0,1-1.209.5,1.567,1.567,0,0,1-.708-.148,1.47,1.47,0,0,1-.5-.4,3.722,3.722,0,0,1-.43-.778Q323.77,396.26,323.606,395.859Zm-6.936-4.8h5.166l-2.606-7.135Z",
    transform: "translate(-311.304 -380.231)",
    fill: "#0058a7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAnswers);
export default __webpack_public_path__ + "static/media/empty-answers.39ab3a6df8210257e102c6995a3d05c9.svg";
export { ForwardRef as ReactComponent };